import PromoProvider from "@/modules/delivery/providers/PromoProvider";
import Promo from "@/modules/delivery/core/models/Promo";


export default {
    state: {
        promos: [],
    },
    getters: {
        promos(state) {
            return state.promos
        },
        getPromoById(state){
            return (id) => {
                let promo = state.promos.find(promo => promo.id === id)
                return promo ? promo : null
            }
        }
    },
    actions:{
        async fetchPromos({commit}) {
            let r = await PromoProvider.fetchPromo()
            let promos = r.data.fetchPromo.map(promo => new Promo(promo)  )
            commit("setPromos", promos)
            return promos
        },
    },
    mutations: {
        setPromos(state, promos) {
            state.promos = promos
        }
    }
}
